import React from "react";
import * as Icons from "lucide-react";
import { whyChoose, keyFeatures } from "../../mock";
import { SectionHeading } from "../SectionHeading";
import Reveal from "../Reveal";
import { CheckCircle2 } from "lucide-react";

const WhyChoose = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <div className="glow-blob w-80 h-80 bg-[#00e5ff] top-40 -right-20" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading
          eyebrow="Why DaddyAnna"
          title="Why Choose"
          highlight="DaddyAnna?"
          subtitle="One of the oldest and most trusted online cricket id providers in India — built on real players, real trust and real results since 2015."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyChoose.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Star;
            return (
              <Reveal key={c.title} delay={i * 90}>
                <div className="card-neon rounded-2xl p-6 h-full">
                  <div className="h-12 w-12 grid place-items-center rounded-xl bg-[#00ff87]/10 text-[#00ff87] mb-4">
                    <Icon size={24} />
                  </div>
                  <h3 className="font-display font-semibold text-lg text-white mb-2">{c.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{c.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <div className="mt-14 rounded-2xl border border-[#00ff87]/15 bg-[#0a0a13] p-8 md:p-10">
            <h3 className="font-display text-2xl font-bold text-white text-center mb-8">
              Our Key <span className="neon-green text-glow-green">Features</span>
            </h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {keyFeatures.map((f) => (
                <div key={f} className="flex items-center gap-3 rounded-xl bg-[#12131f] px-4 py-3">
                  <CheckCircle2 size={18} className="text-[#00ff87] shrink-0" />
                  <span className="text-gray-200 text-sm">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default WhyChoose;
